/** Exam hosts (annales., bac., brevet.): head, entry copy, catalogue labels. */
const ANNALES = 'annales.neoprof.fr';
const BAC = 'bac.neoprof.fr';
const BREVET = 'brevet.neoprof.fr';

const page = (title, description, heading, lead = description) => Object.freeze({ title, description, heading, lead });

export const EXAM_HOSTS_COPY = Object.freeze({
  PAGES: Object.freeze({
    [ANNALES]: Object.freeze({
      '/': page(
        'Annales de maths du brevet et du bac en PDF — NeoProf',
        'Les sujets de mathématiques du brevet et du bac (Première, Terminale) en PDF, classés par diplôme et par année.',
        'Annales de maths : brevet et bac en PDF',
      ),
      '/brevet': page(
        'Annales du brevet de maths en PDF — NeoProf',
        'Les sujets de mathématiques du brevet en PDF, classés par année.',
        'Annales du brevet de maths',
      ),
      '/bac/premiere': page(
        'Annales du bac de maths de Première en PDF — NeoProf',
        'Les sujets de l’épreuve anticipée de mathématiques de Première en PDF, classés par année.',
        'Annales du bac de maths de Première',
      ),
      '/bac/terminale': page(
        'Annales du bac de maths de Terminale en PDF — NeoProf',
        'Les sujets de spécialité mathématiques de Terminale en PDF, classés par année.',
        'Annales du bac de maths de Terminale',
      ),
    }),
    [BREVET]: Object.freeze({
      '/': page(
        'Brevet de maths : entraîne-toi sur de vrais sujets — NeoProf',
        'Choisis un sujet du brevet, passe-le en PDF ou en ligne en conditions réelles, puis lis ta correction.',
        'Brevet de maths : de vrais sujets, en conditions réelles',
      ),
    }),
    [BAC]: Object.freeze({
      '/': page(
        'Bac de maths : Première ou Terminale, de vrais sujets — NeoProf',
        'Choisis ton niveau, puis un sujet du bac de maths : en PDF ou en ligne, en conditions réelles, avec la correction.',
        'Bac de maths : choisis ton niveau',
      ),
    }),
  }),
  CATALOGUE: Object.freeze({
    EYEBROW: 'Annales',
    FILTER_LABEL: 'Filtrer par diplôme',
    ALL: 'Tous',
    PDF: 'Sujet PDF',
    PDF_LABEL: (name, year) => `Sujet PDF ${name} ${year}`,
    PRACTICE: 'S’entraîner en conditions réelles',
    EMPTY: 'Aucun sujet pour ce diplôme.',
  }),
});
